import { cancelActiveRemittanceOrder } from './activeRemittanceOrder';
import { decryptObject } from './cryptoUtils';

export type LogoutReason = 'replaced' | 'expired' | 'unknown';

let isLoggingOut = false;
let hasRedirected = false;

export const isLogoutInProgress = (): boolean => isLoggingOut;

const EXPIRED = 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

const clearLocalSession = (): void => {
  localStorage.clear();
  document.cookie = `session=; ${EXPIRED}`;
  document.cookie = `session_e=; ${EXPIRED}`;
  document.cookie = `session_status=; ${EXPIRED}`;
};

const readTenantSlug = (): string => {
  try {
    const raw = localStorage.getItem('USER');
    if (!raw) return '';
    const decoded = decryptObject(raw);
    const correspondent = decoded?.correspondent;
    return correspondent != null ? String(correspondent) : '';
  } catch {
    return '';
  }
};

const loginPath = (tenant: string, reason?: LogoutReason): string => {
  const base = tenant ? `/auth/login/${tenant}` : '/login';
  if (!reason || reason === 'unknown') return base;
  return `${base}?reason=${reason}`;
};

export const historyNavigation = {
  replace(url: string): void {
    window.location.replace(url);
  },
};

export const forcedLogout = (reason: LogoutReason = 'unknown'): void => {
  if (hasRedirected) return;
  hasRedirected = true;
  isLoggingOut = true;

  const tenant = readTenantSlug();
  clearLocalSession();
  historyNavigation.replace(loginPath(tenant, reason));
};

export const userInitiatedLogout = async (profileId?: string | number): Promise<void> => {
  if (isLoggingOut) return;

  isLoggingOut = true;

  try {
    await cancelActiveRemittanceOrder();
  } catch (error) {
    console.warn('[authCleanup] No se pudo cancelar el pedido de remitancia activo:', error);
  }

  if (profileId !== undefined && profileId !== null && profileId !== '') {
    try {
      const { logoutService } = await import('@shared/services/api/authService');
      await Promise.race([
        logoutService(profileId),
        new Promise((_, reject) => setTimeout(() => reject(new Error('logout timeout')), 3000)),
      ]);
    } catch (error) {
      console.warn('[authCleanup] No se pudo notificar al backend del cierre de sesión:', error);
    }
  }

  forcedLogout('unknown');
};

export const logout = (): void => forcedLogout('unknown');

export const _resetLogoutState = (): void => {
  isLoggingOut = false;
  hasRedirected = false;
};
